<template>
  <v-card-actions class="flex-column">
    <v-divider class="flex-shrink-0 w-100 mb-4"></v-divider>
    <div class="d-flex align-start w-100">
      <span class="grey--text"
        >Page {{ innerValue + 1 }} of {{ pageCount }}</span
      >
      <v-spacer></v-spacer>
      <v-btn text large @click="prev" v-if="hasPrev" :disabled="loading"
        >Back</v-btn
      >
      <v-btn
        v-if="hasNext"
        color="primary"
        large
        @click="next"
        :loading="loading"
        :disabled="stopped"
      >
        Next
      </v-btn>
      <v-btn
        v-else
        color="primary"
        large
        @click="$emit('submit')"
        :loading="loading"
        :disabled="stopped"
      >
        Submit
      </v-btn>
    </div>
  </v-card-actions>
</template>

<script>
import { showQuestion, roadBlockQuestion } from "../constants/Survey";

export default {
  data: () => ({
    innerValue: 0,
  }),
  props: {
    pages: {
      type: Array,
      default: () => [],
    },
    value: {
      type: Number,
      default: 0,
    },
    pageErrors: {
      type: Array,
      default: () => [],
    },
    validate: {
      type: Function,
    },
    byPassValidation: {
      type: Boolean,
    },
    skipEmpty: {
      type: Boolean,
      default: true,
    },
    formData: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
    },
  },
  computed: {
    pageCount() {
      return this.pages.length;
    },
    pageQuestionCounts() {
      let results = [];

      this.pages.forEach((x) => {
        let count = 0;
        x.questions?.forEach((y) => {
          if (showQuestion(y, this.formData)) count++;
        });

        results.push(count);
      });

      return results;
    },
    stopped() {
      let results = [];

      this.pages.forEach((x) => {
        let count = 0;
        x.questions?.forEach((y) => {
          if (roadBlockQuestion(y, this.formData)) count++;
        });

        results.push(count);
      });

      return results.reduce((x,y) => x + y, 0) > 0;
    },
    nextPageWithQuestions() {
      for (var i = this.innerValue + 1; i < this.pageCount; i++) {
        if (this.pageQuestionCounts[i] > 0) return i;
      }

      return null;
    },
    prevPageWithQuestions() {
      for (var i = this.innerValue - 1; i > -1; i--) {
        if (this.pageQuestionCounts[i] > 0) return i;
      }

      return null;
    },
    hasNext() {
      if (this.skipEmpty) return this.nextPageWithQuestions != null;
      else return this.innerValue < this.pageCount - 1;
    },
    hasPrev() {
      if (this.skipEmpty) return this.prevPageWithQuestions != null;
      else return this.innerValue > 0;
    },
  },
  watch: {
    value(val) {
      if (val != this.innerValue) this.innerValue = val;
    },
    innerValue(value) {
      if (value != this.value) this.$emit("input", value);
    },
  },
  methods: {
    next() {
      if (this.byPassValidation || (this.validate && this.validate()))
        this.innerValue = this.skipEmpty
          ? this.nextPageWithQuestions
          : this.innerValue + 1;
    },
    prev() {
      this.innerValue = this.skipEmpty
        ? this.prevPageWithQuestions
        : this.innerValue - 1;
    },
  },
  mounted() {
    if (this.value) this.innerValue = this.value;
  },
};
</script>
